<ion-slides [options]="{ slidesPerView: 'auto', zoom: false, grabCursor: true, centeredSlides: true }">
    <ion-slide *ngFor="let number of [1, 2, 3, 4, 5, 6, 7]" (click) = openImage(number)>
        <img width="325px" height="480px" src="./assets/images/social/{{number}}.png" />
    </ion-slide>
</ion-slides>